import { memo } from "react";
import { Modal, Button } from "react-bootstrap";
import { useModal } from "../../Context/ModalContext";

function GlobalModal() {
  const { showModal, description, closeModal, title } = useModal();

  if (!showModal) {
    return null;
  }

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="secondary" onClick={closeModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

GlobalModal.displayName = "GlobalModal";

export default memo(GlobalModal);
